import { Component, Input, OnInit } from '@angular/core';
import { CommonEntityService } from 'src/app/common/services/common-entity.service';

interface TriggerViewRow {
  triggerName: string;
  optionValue: string;
}

@Component({
  selector: 'app-animation-trigger-map-view',
  templateUrl: './animation-trigger-map-view.component.html',
  styleUrls: ['./animation-trigger-map-view.component.sass'],
})
export class AnimationTriggerMapViewComponent implements OnInit {
  @Input() field: any;
  @Input() record: any;

  rows: TriggerViewRow[] = [];

  constructor(private commonEntityService: CommonEntityService) {}

  async ngOnInit(): Promise<void> {
    const value = this.record?.[this.field?.key];
    if (!value || typeof value !== 'object' || Array.isArray(value)) return;

    const entries = Object.entries(value) as [string, string][];
    if (!entries.length) return;

    let allTriggers: any[] = [];
    try {
      allTriggers = await this.commonEntityService.findAllWithQuery('animation-triggers', {
        query: {},
        select: 'name id _id',
        sort: { name: 1 },
        autopopulate: false,
        virtuals: false,
        isOptions: true,
      } as any) || [];
    } catch { /* leave empty */ }

    this.rows = entries.map(([triggerId, optionValue]) => {
      const trigger = allTriggers.find((t: any) => String(t.id) === String(triggerId));
      return {
        triggerName: trigger?.name ?? `Trigger #${triggerId}`,
        optionValue,
      };
    });
  }
}
